<template lang="pug">


  a( 
    :href="url" 
    :target="target"
    @focus="onMouseEnter" 
    @mouseenter="onMouseEnter" 
    @blur="onMouseLeave" 
    @mouseleave="onMouseLeave"  
    ).outline-btn
    .bg 
    .inner
      p {{ copy }}
      .read-more-arrow( ref="readMore" v-if="showArrow" )
        read-more-svg

</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import { MODAL_STATES, PATHS , EVENTS} from '@/config/app'
import CloseSvg from '@/assets/svgs/close.svg'
import ReadMoreSvg from '@/assets/svgs/read-more-arrow.svg'
import gsap from 'gsap'
import Env from '@/config/env'
import Communicator from '@/helpers/Communicator'

export default { 

  props: {
    url: String,
    copy: String,
    theme: String,
    target: {
      type: String,
      default: '_self'
    },
    showArrow: {  
      type: Boolean,
      default: true
    },
    hideOutline: {  
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('app', ['motion_clamp'])
  },

  components: {
    CloseSvg,
    ReadMoreSvg
  },

  mounted(){
    this.$el.classList.toggle('dark', this.theme === 'dark')
    this.$el.classList.toggle('outline-none', this.hideOutline)
  },

  methods: {

    enter(duration = 1, delay = 0){ 
      gsap.killTweensOf(this.$el)
      gsap.to(this.$el, (duration * this.motion_clamp), { opacity: 1, delay: (delay * this.motion_clamp), ease: 'sine.inOut' }) 
    },

    leave(duration = 0.5, delay = 0){
      gsap.killTweensOf(this.$el)
      gsap.to(this.$el, (duration * this.motion_clamp), { opacity: 0, delay: (delay * this.motion_clamp), ease: 'sine.out' }) 
    },

    onMouseEnter( ){ 
      Communicator.trigger(EVENTS.MOUSE_ENTER)
    },

    onMouseLeave( ){
      Communicator.trigger(EVENTS.MOUSE_LEAVE)
    }
  }
}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
 

.outline-btn
  border-radius: 35px
  height: 70px
  min-width: 150px
  display: inline-block
  position: relative 
  color: white
  opacity: 0
  cursor: pointer
  outline: none 

  &:hover,
  &:focus,
  &:active 
  
    .desktop & 

      .bg
        transition: all 0.1s ease-out
        border: 2px solid rgba(40, 43, 96, 0)
        transform: scale(1.05) 
        background: rgba(255,255,255,1)

    .inner 

      p
        color: #373C85 


      .read-more-arrow  
        svg 
          stroke: #373C85


  &.dark
    color: #373C85
    border: 2px solid rgba(55, 60, 133, 0.4)

  &.outline-none
    border: none
    height: 80px

    .bg
      border: none
 
    .inner

      @media all and (max-width: $bp-mobile) 
        padding: 0

  @media all and (max-width: $bp-mobile)
    min-width: auto

  .bg
    transform: scale(1) 
    transition: all 0.3s ease-in-out
    opacity: 1
    position: absolute
    top: 0
    height: 100%
    width: 100%
    border-radius: 35px  
    background: rgba(255,255,255,0)
    border: 2px solid rgba(146, 151, 255, 0.3)

  .inner
    position: relative
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    padding: 0 40px
 

    .read-more-arrow      
      height: 10px
      top: 50%
      margin: 2px 0 0 11px

      svg
        display: block
        stroke: white

    p 
      font-size: 1.5rem
      font-family: "Regular"
 


</style>
